import { render } from "./DottedPaginationView.vue?vue&type=template&id=c8329e5a"
import script from "./DottedPaginationView.vue?vue&type=script&lang=js"
export * from "./DottedPaginationView.vue?vue&type=script&lang=js"

import "./DottedPaginationView.vue?vue&type=style&index=0&id=c8329e5a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__